// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@assets/queue/tips_bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.queue-tips {
    width: 100%;
    height: 6vw;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    color: white;
    font-family: 'Kim';
    text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
    position: relative;
    display: flex;
    justify-content: center;
  }
  .queue-tips-container {
    width: 40vw;
    text-align: center;
    font-size: 14px;
  }
  .queue-tips-container > div:first-child {
    margin-top: 0.2vw;
    margin-bottom: 0.4vw;
  }
  .queue-tips-container > div:last-child{
    height: 2.8vw;
  }
  .queue-tips-arrow {
    position: absolute;
    top: 2vw;
    color: coral;
    font-size: 1.5vw;
    cursor: pointer;
  }
  .prev {
    left: 25vw;
  }
  .next {
    right: 25vw;
  }
  .queue-tips-text {
    font-size: 1.2vw;
    font-family: 'Kim';
    text-align: center;
    color: cyan;
  }`, "",{"version":3,"sources":["webpack://./src/components/queueTips/QueueTips.style.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,WAAW;IACX,yDAAkD;IAClD,wBAAwB;IACxB,2BAA2B;IAC3B,4BAA4B;IAC5B,YAAY;IACZ,kBAAkB;IAClB,iEAAiE;IACjE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;EACb","sourcesContent":[".queue-tips {\n    width: 100%;\n    height: 6vw;\n    background-image: url('@assets/queue/tips_bg.png');\n    background-size: contain;\n    background-position: center;\n    background-repeat: no-repeat;\n    color: white;\n    font-family: 'Kim';\n    text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n    position: relative;\n    display: flex;\n    justify-content: center;\n  }\n  .queue-tips-container {\n    width: 40vw;\n    text-align: center;\n    font-size: 14px;\n  }\n  .queue-tips-container > div:first-child {\n    margin-top: 0.2vw;\n    margin-bottom: 0.4vw;\n  }\n  .queue-tips-container > div:last-child{\n    height: 2.8vw;\n  }\n  .queue-tips-arrow {\n    position: absolute;\n    top: 2vw;\n    color: coral;\n    font-size: 1.5vw;\n    cursor: pointer;\n  }\n  .prev {\n    left: 25vw;\n  }\n  .next {\n    right: 25vw;\n  }\n  .queue-tips-text {\n    font-size: 1.2vw;\n    font-family: 'Kim';\n    text-align: center;\n    color: cyan;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
